import { employmentDocumentMessages, romeTimeMessages } from '@fide/shared';
import type { Messages } from '../lib/i18n';

export const es: Messages = {
  ...romeTimeMessages('es'),
  ...employmentDocumentMessages('es'),
  "org.title": "Organización",
  "org.explanation": "Las unidades describen el organigrama y no conceden acceso. El responsable directo gestiona las solicitudes del equipo. El ámbito ampliado se asigna explícitamente: incluye equipos subordinados a través de responsables activos, sin acceso HR a documentos o contratos.",
  "org.units": "Departamentos y unidades",
  "org.newUnit": "Nueva unidad",
  "org.archived": "Archivada",
  "org.noUnits": "No hay unidades configuradas.",
  "org.people": "Personas y responsabilidades",
  "org.search": "Buscar nombre o matrícula",
  "org.count": "Personas encontradas: {n}",
  "org.manager": "Responsable directo",
  "org.subtree": "Gestiona también equipos subordinados",
  "org.direct": "Solo personas a su cargo directo",
  "org.unassigned": "Sin asignar",
  "org.unitEditor": "Unidad organizativa",
  "org.name": "Nombre de unidad",
  "org.parent": "Unidad superior",
  "org.root": "Raíz de la empresa",
  "org.archive": "Archivar unidad",
  "org.archiveHint": "Solo se archiva una unidad sin personas ni subunidades. No se borran datos.",
  "org.clearManager": "Quitar responsable",
  "org.findManager": "Buscar un responsable activo",
  "org.accessWarning": "La cadena cambia quién puede ver presencias, saldos y solicitudes y aprobarlas. Cada nivel ampliado requiere un responsable activo con rol habilitado. Sin autoaprobación. Los correos siguen dirigidos al responsable directo y a HR.",
  "org.confirm": "Confirmo la estructura y el ámbito de acceso mostrados.",
  "org.invalid": "Configuración inválida: revisa rol, estado y unidad.",
  "org.cycle": "La estructura crearía un ciclo entre unidades o responsables.",
  "org.stale": "La estructura cambió. Cierra la edición, recarga y vuelve a intentarlo.",
  "org.busy": "Hay otra modificación en curso. Inténtalo de nuevo.",
  "org.inUse": "La unidad contiene personas o subunidades. Reasígnalas antes de archivarla.",
  "org.limit": "Se alcanzó el límite de 500 unidades.",
  "wizard.identity": "Persona y destinatario",
  "wizard.employment": "Relación laboral",
  "wizard.documents": "Documentos y acuerdos",
  "wizard.documentsHint": "Define lo que RR. HH. deberá verificar después del alta. El destinatario sigue siendo el correo revisado en el primer paso.",
  "wizard.employmentContractRequired": "El contrato laboral se añadirá a la lista y podrá vincularse con la versión laboral desde la ficha del trabajador.",
  "wizard.individualAgreement": "Se prevé un acuerdo individual separado",
  "wizard.noSignatureClaim": "La lista solo registra la comprobación administrativa: no prueba firma, entrega, aceptación ni validez legal.",
  "wizard.required": "Requerido",
  "wizard.notRequired": "No previsto",
  "wizard.review": "Resumen e invitación",
  "wizard.steps": "Pasos del alta",
  "wizard.next": "Continuar",
  "wizard.previous": "Atrás",
  "wizard.create": "Crear trabajador y enviar invitación",
  "wizard.confirm": "He revisado datos, empresa y destinatario. Confirmo la creación de la ficha y el envío de la invitación.",
  "wizard.delivery": "La invitación de acceso se enviará a {email}.",
  "wizard.scope": "Crear la ficha no firma un contrato ni certifica una contratación o la aplicabilidad del CCNL.",
  "wizard.unknown": "No registrado",
  "wizard.fixRequired": "Completa o corrige los datos y reintenta la lectura de referencias antes de confirmar.",
  'employment.datesInvalid':'Revisa las fechas: indica el inicio antes del fin de contrato/prueba; inicio no posterior a la vigencia, contrato no vencido en esa fecha y prueba dentro del período laboral.',
  "employment.employment_start": "Inicio de la relación laboral",
  "employment.contract_end": "Fin de contrato comunicado",
  "employment.probation_end": "Fin de prueba comunicado",
  "employment.datesHint": "Fechas confirmadas por HR: vacío significa dato no registrado. No calculan la prueba, no renuevan el contrato ni causan bajas automáticas.",
  'draft.title':'Altas por completar',
  'draft.hint':'Borradores reservados a HR y titular; se eliminan tras 30 días sin guardar. Guardar no crea trabajadores ni envía correos.',
  'draft.empty':'No hay borradores guardados.',
  'draft.unnamed':'Borrador sin nombre',
  'draft.completed':'Trabajador creado: comprueba la invitación en su ficha.',
  'draft.delivery':'Entrega de invitación',
  'draft.resume':'Retomar',
  'draft.discard':'Quitar borrador',
  'draft.discardConfirm':'¿Quitar el borrador o recordatorio? No se elimina al trabajador ya creado.',
  'draft.closeConfirm':'¿Cerrar sin guardar? Usa “Guardar borrador y cerrar” para retomarlo después.',
  'draft.save':'Guardar borrador y cerrar',
  'draft.invalid':'Borrador no válido. Revisa los campos; no introduzcas adjuntos ni datos médicos.',
  'draft.conflict':'Borrador modificado o alta ya completada. Cierra y retoma desde la lista actualizada. Comprueba al trabajador antes de reenviar la invitación.',
  'draft.unavailable':'Borrador caducado o no disponible. Recarga la lista.',
  'draft.limit':'Límite de 100 borradores alcanzado. Quita los innecesarios.',
  "calendarConfig.invalid": "Fecha o tipo inválidos. Revisa los datos.",
  "calendarConfig.stale": "Esta excepción cambió. Recarga antes de guardar.",

  "workCalendar.company": "Excepción empresarial",
  "workCalendar.site": "Excepción de sede",
  "workCalendar.personal": "Excepción personal",

  "calendarConfig.title": "Festivos y excepciones",
  "calendarConfig.hint": "Se aplican al día de inicio del turno. Un día laborable usa los tramos guardados, no inventa horas. Sin campos para datos médicos.",
  "calendarConfig.empty": "Sin excepciones configuradas",
  "calendarConfig.scope": "Empresa o sede",
  "calendarConfig.kind": "Tipo",
  "calendarConfig.company": "Toda la empresa",
  "calendarConfig.personal": "Excepción personal",
  "calendarConfig.patron": "Patronal: día no laborable",
  "calendarConfig.closure": "Cierre: día no laborable",
  "calendarConfig.workday": "Día laborable",
  "calendarConfig.confirm": "Confirmo fecha, ámbito y tipo",

  "workCalendar.title": "Calendario previsto",
  "workCalendar.hint": "Previsión desde jornadas guardadas y festivos nacionales. No certifica presencia ni recalcula solicitudes o saldos.",
  "workCalendar.unknown": "Jornada o referencia laboral incompleta",
  "workCalendar.national": "Festivo nacional",
  "workCalendar.minutes": "Minutos de horario previstos",
  "workCalendar.previous": "Mes anterior",
  "workCalendar.next": "Mes siguiente",

  "schedule.title": "Jornada semanal",
  "schedule.hint": "Hora italiana. Las pausas son huecos; no modifica fichajes, vacaciones ni saldos.",
  "schedule.empty": "Jornada sin configurar",
  "clockPolicy.title": "Tolerancias horarias",
  "clockPolicy.hint": "Valores declarados por HR para esta versión de jornada y sede; no se infieren del CCNL.",
  "clockPolicy.notConfigured": "No hay tolerancias configuradas para esta jornada.",
  "clockPolicy.effectiveFrom": "Vigente desde",
  "clockPolicy.lateStart": "Tolerancia después del inicio previsto",
  "clockPolicy.earlyEnd": "Tolerancia antes del fin previsto",
  "clockPolicy.minutes": "minutos",
  "clockPolicy.scheduleVersion": "Versión de jornada",
  "clockPolicy.source.label": "Origen declarado",
  "clockPolicy.source.company_policy": "Política de empresa",
  "clockPolicy.source.employment_agreement": "Acuerdo laboral",
  "clockPolicy.source.consultant_review": "Revisión del asesor laboral",
  "clockPolicy.noEffect": "Solo se registra y muestra. No cambia fichajes, horas, nómina ni informes; HR debe revisar la regla antes de usarla.",
  "clockPolicy.confirm": "Confirmo los valores declarados y su fecha de vigencia.",
  "clockPolicy.addVersion": "Registrar una versión de tolerancias",
  "clockPolicy.stale": "La política cambió en otra sesión. Vuelve a cargarla.",
  "clockPolicy.scheduleMismatch": "La versión de jornada elegida no está vigente en esta fecha.",
  "schedule.days": "Lunes|Martes|Miércoles|Jueves|Viernes|Sábado|Domingo",
  "schedule.next": "Día siguiente",
  "schedule.incompatible": "Datos laborales cambiados: jornada pendiente de confirmación.",
  "schedule.minutes": "Minutos semanales",
  "schedule.day": "Día",
  "schedule.start": "Inicio",
  "schedule.end": "Fin",
  "schedule.add": "Añadir tramo",
  "schedule.remove": "Eliminar tramo",
  "schedule.confirm": "Confirmo los tramos y la fecha",
  "schedule.invalid": "Tramos o total semanal inválidos.",

  "companyCcnl.title": "CCNL empresariales con vigencia",
  "companyCcnl.hint": "Guardar la primera referencia activa el control de nuevas asignaciones individuales: código y fecha deben estar en esta lista. El historial no cambia. Son fechas organizativas, no certifican aplicabilidad legal.",
  "companyCcnl.active": "Control activo: las nuevas asignaciones deben corresponder a un periodo empresarial disponible.",
  "companyCcnl.closeEnd": "Fecha final de asignación",
  "companyCcnl.initial": "Referencia CCNL inicial",
  "audit.table.company_ccnls": "Referencias CCNL empresariales",
  "audit.field.company_ccnl_id": "Referencia CCNL asignada",
  "audit.field.ccnl_policy_enabled": "Control de referencias CCNL empresariales",
  "audit.field.effective_from": "Fecha de inicio",
  "audit.field.effective_to": "Fecha final",
  "audit.field.closed_at": "Fecha de cierre",
  "audit.field.voided_at": "Fecha de retirada",
  "audit.field.code": "Código",
  "companyCcnl.empty": "Lista sin configurar: las fichas nuevas siguen usando referencias libres.",
  "companyCcnl.open": "Sin fecha final",
  "companyCcnl.end": "Fecha final de asignación (opcional)",
  "companyCcnl.close": "Cerrar periodo",
  "companyCcnl.closeHint": "El cierre es definitivo y no puede ser anterior a hoy ni a asignaciones futuras. Las relaciones existentes se conservan.",
  "companyCcnl.voidHint": "Retira solo una referencia no utilizada. El control permanece activo incluso con la lista vacía.",
  "companyCcnl.invalid": "Selecciona un CCNL empresarial disponible en la fecha de inicio.",
  "companyCcnl.overlap": "Periodos solapados para el mismo código.",
  "companyCcnl.inUse": "Referencia retirada o utilizada: no se puede retirar.",
  "companyCcnl.closeInvalid": "Fecha final inválida o incompatible con asignaciones futuras.",
  "employment.companyCcnlPeriod": "Periodo de la referencia CCNL empresarial: {from} – {to}",

  'worklists.updated': 'Los datos cambiaron. Lista actualizada desde la primera página.',
  "company.identityHint": "La partida IVA identifica esta empresa y no se cambia desde la ficha. Los campos opcionales no son requisitos de activación; el CCNL aquí es una referencia, no una regla automática de acumulación.",
  "company.edit": "Editar datos de empresa",
  "company.setup": "Configuración inicial",
  "company.setupHint": "Estos controles muestran datos configurados; no certifican que el servicio esté listo. Comprueba también kiosco, invitaciones, permisos y apertura del cedolino en el dispositivo.",
  "company.registered": "Empresa registrada",
  "company.sites": "Sedes registradas: {count}. Abre para configurar kioscos y métodos de fichaje.",
  "company.recipients": "Empleados con cuenta y clave activas: {ready} / {total}. Excluye titulares, HR y responsables. Revisa invitaciones y dispositivos en las fichas.",
  "company.invalid": "Revisa el formato o la longitud de este campo.",
  "company.conflict": "Los datos cambiaron o ya no tienes acceso. Cancela, recarga la página y revisa antes de reintentar.",
  "company.savedRefreshFailed": "Los cambios se guardaron, pero falló la actualización de los datos de la sesión. Reintenta la lectura; no vuelvas a guardar.",
  "register.created": "Empresa registrada",
  "register.createdReady": "Cargando el acceso a la empresa.",
  "register.createdRefreshFailed": "La empresa quedó registrada, pero falló la carga del acceso. Reintenta la lectura sin registrarla de nuevo.",

  "invitations.title": "Invitaciones",
  "invitations.historyHint": "Estado del enlace, no prueba de entrega del correo. El token no se conserva en claro: para compartirlo de nuevo hay que crear otro enlace, invalidando el anterior.",
  "invitations.status.pending": "Válida",
  "invitations.status.expired": "Caducada",
  "invitations.status.redeemed": "Aceptada",
  "invitations.status.revoked": "Revocada",
  "invitations.created": "Creada",
  "invitations.expires": "Caduca",
  "invitations.redeemed": "Aceptada el",
  "invitations.revoke": "Revocar enlace",
  "invitations.confirmRevoke": "¿Revocar este enlace? Ya no podrá usarse para activar la cuenta.",
  "invitations.empty": "No hay invitaciones registradas.",
  'directory.filters': 'Filtros de empleados',
  'directory.search': 'Nombre, matrícula, correo o código fiscal',
  'directory.unassigned': 'Sin sede asignada',
  'directory.sort': 'Ordenar por',
  'directory.sort.name-asc': 'Nombre · A–Z',
  'directory.sort.name-desc': 'Nombre · Z–A',
  'directory.sort.number-asc': 'Matrícula · ascendente',
  'directory.sort.number-desc': 'Matrícula · descendente',
  'directory.results': 'Empleados filtrados: {filtered} / {total}. Sede, rol y estado son los actuales.',
  'directory.unavailable': 'La lista y los recuentos no están disponibles hasta que los datos se carguen correctamente.',
  'directory.noResults': 'Ningún empleado coincide con los filtros. Restablece los filtros para ver la lista completa.',
  'directory.pagination': 'Páginas de empleados',
  'directory.tableScroll': 'Tabla de empleados con desplazamiento horizontal',
  "employees.myProfile": "Mi ficha",
  "member.tab.employment": "Datos laborales",
  "employment.reload": "Recargar",
  "employment.saved": "Versión guardada.",
  "employment.new": "Nueva versión / sustitución",
  "employment.copy": "Usar como base",
  "employment.withdraw": "Anular versión futura",
  "employment.confirmWithdraw": "¿Anular esta versión futura? Su registro seguirá visible.",
  "employment.save": "Guardar versión",
  "employment.stale": "Los datos han cambiado. Recarga antes de guardar.",
  "employment.dateInvalid": "La fecha no puede preceder a la última versión ni modificar el pasado.",
  "employment.notFuture": "Solo se puede anular una versión futura todavía válida.",
  "employment.title": "Datos laborales",
  "employment.hint": "Referencias introducidas por HR: no son un contrato firmado ni activan el cálculo de saldos. El cargo no concede permisos de acceso.",
  "employment.job_title": "Mansione / cargo",
  "employment.category": "Categoría",
  "employment.level": "Nivel",
  "employment.contract_type": "Tipo de contrato",
  "employment.ccnl_reference": "Referencia CCNL",
  "employment.weekly_hours": "Horas semanales",
  "employment.effective_from": "Vigente desde",
  "employment.empty": "HR todavía no ha cargado los datos laborales.",
  "ccnl.search": "Buscar por código, nombre o sector",
  "ccnl.snapshot": "Copia local del catálogo generada el {date}.",
  "ccnl.stale": "La copia del catálogo requiere revisar su actualización (umbral operativo: 14 días). Las referencias guardadas se conservan; confirma el texto y las renovaciones con el asesor.",
  "ccnl.effectiveFrom": "Inicio de vigencia indicado por CNEL",
  "ccnl.expiry": "Vencimiento contractual indicado por CNEL",
  "ccnl.classification": "Estado de clasificación CNEL",
  "ccnl.agreement": "Tipo de acuerdo",
  "ccnl.received": "Fecha de recepción CNEL",
  "ccnl.datesHint": "Estos datos describen el registro del catálogo. Un vencimiento pasado o un estado de clasificación no determinan por sí solos la aplicabilidad del CCNL. Confirma el texto y las renovaciones con el asesor.",
  "ccnl.missing": "La referencia guardada no aparece en esta copia del catálogo. Se conserva; verifica el código con el asesor antes de sustituirlo.",
  "ccnl.selected": "Convenio colectivo CNEL",
  "ccnl.none": "Selecciona una referencia",
  "ccnl.unknown": "Pendiente de confirmar con la asesoría",
  "ccnl.legacy": "Referencia anterior: {value}",
  "ccnl.unavailable": "El catálogo CNEL no está disponible. Reinténtalo cuando vuelva la conexión.",
  "ccnl.hint": "Fuente: Archivo Corrente del CNEL. La selección es una referencia que debe confirmar la asesoría; no determina la aplicabilidad ni calcula saldos automáticamente.",
  "employment.onboardingHint": "Completa los datos laborales antes de invitar al trabajador. Son referencias operativas, no un contrato firmado ni activan cálculos automáticos de horario o vacaciones.",
  "employment.current": "Vigente",
  "employment.past": "Histórico",
  "employment.future": "Programado",
  "employment.voided": "Anulado / sustituido",
  'app.tagline': 'Portal de empresa',
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.company': 'Empresa',
  'common.language': 'Idioma',
  'common.loading': 'Cargando…',
  'common.edit': 'Editar',
  'common.add': 'Añadir',
  'common.copy': 'Copiar',
  'common.copied': 'Copiado',
  'common.retry': 'Reintentar',
  'common.logout': 'Salir',
  'common.actions': 'Acciones',
  'common.none': 'Ninguno',
  'common.optional': 'opcional',

  'nav.presence': 'Presencias',
  'nav.cartellino': 'Cartellino',
  'nav.employees': 'Empleados',
  'nav.sites': 'Sedes y quioscos',
  'nav.payroll': 'Documentos',
  'nav.compensation': 'Retribuciones',
  'nav.requests': 'Solicitudes',
  'nav.communications': 'Comunicaciones',
  'communications.eyebrow': 'TABLÓN DE LA EMPRESA',
  'communications.title': 'Comunicaciones',
  'communications.hint': 'Avisos en texto simple visibles para trabajadores activos. Sin adjuntos ni confirmación de lectura.',
  'communications.compose': 'Nuevo aviso',
  'communications.subject': 'Título',
  'communications.body': 'Mensaje',
  'communications.expiry': 'Caducidad (opcional)',
  'communications.scope': 'Será visible para todos los trabajadores activos de la empresa.',
  'communications.publish': 'Publicar aviso',
  'communications.published': 'Aviso publicado.',
  'communications.error': 'No se pudo completar la operación. Inténtalo de nuevo.',
  'communications.archiveTitle': 'Avisos publicados',
  'communications.archive': 'Archivar',
  'communications.publishedAt': 'Publicado el {date}',
  'communications.expiresAt': 'Caduca el {date}',
  'communications.empty': 'No hay avisos activos.',
  'communications.results': 'Avisos {from}–{to} de {total}',
  'communications.pagination': 'Páginas de avisos',
  'communications.archiveConfirmTitle': '¿Archivar el aviso?',
  'communications.archiveConfirmBody': 'El aviso «{title}» dejará de ser visible para los trabajadores. ¿Confirmas?',
  'common.skipToContent': 'Ir al contenido',
  'nav.audit': 'Registro de actividad',
  'nav.settings': 'Ajustes',

  'config.missingTitle': 'Portal sin configurar',
  'config.missingBody':
    'Define VITE_SUPABASE_URL y VITE_SUPABASE_PUBLISHABLE_KEY en apps/web-portal/.env (ver .env.example) y reinicia.',

  'login.title': 'Entra en el portal',
  'login.subtitle': 'Sin contraseñas: un código por e-mail o la passkey de este dispositivo.',
  'login.email': 'E-mail de trabajo',
  'login.sendCode': 'Envíame el código',
  'login.codeSent': 'Te hemos enviado un código a {email}.',
  'login.linkHint': 'Si el e-mail trae un enlace en lugar del código, ábrelo en este mismo navegador.',
  'login.code': 'Código de 6 cifras',
  'login.verify': 'Entrar',
  'login.passkey': 'Entrar con passkey',
  'login.or': 'o',
  'login.changeEmail': 'Usar otra dirección',

  'access.noCompanyTitle': 'Ninguna empresa vinculada a esta cuenta',
  'access.noCompanyBody': 'Si eres titular o RR. HH. de una empresa, regístrala. Si eres empleado, usa tu invitación y la app Fide.',
  'access.registerCompany': 'Registra tu empresa',
  'access.employeeTitle': 'Este portal es para RR. HH. y titulares',
  'access.employeeBody': 'Para fichar, ver tus nóminas y pedir vacaciones usa la app Fide en el móvil.',

  'register.title': 'Registra tu empresa',
  'register.legalName': 'Razón social',
  'register.vat': 'Partita IVA',
  'register.vatInvalid': 'Partita IVA no válida (11 cifras con dígito de control).',
  'register.ownerName': 'Tu nombre y apellidos',
  'register.fiscalCode': 'Codice fiscale de la empresa',
  'register.pec': 'PEC',
  'register.sdi': 'Código SDI',
  'register.inps': 'Matrícula INPS',
  'register.ccnl': 'Convenio (CCNL)',
  'register.address': 'Domicilio social',
  'register.submit': 'Registrar empresa',
  'register.note': 'Serás titular de la cuenta de empresa y podrás añadir a RR. HH. y a los empleados justo después.',

  'presence.title': 'Presencias',
  'presence.live': 'En tiempo real',
  'presence.inNow': 'Dentro ahora',
  'presence.today': 'Fichajes de hoy',
  'presence.empty': 'Todavía no hay fichajes hoy.',
  'presence.in': 'Entrada',
  'presence.out': 'Salida',
  'presence.receipt': 'Recibo',
  'presence.employee': 'Empleado',
  'presence.time': 'Hora',
  'presence.method': 'Método',
  'presence.flags': 'Avisos',

  'report.title': 'Informe mensual para el asesor laboral',
  'report.body': 'Entradas, salidas, horas trabajadas, ausencias aprobadas y anomalías por empleado y día, en hora italiana. Sirve para elaborar nóminas y el LUL, no los sustituye. El archivo se genera en este navegador.',
  'report.scopeNotice': 'BORRADOR PARA REVISIÓN DEL CONSULENTE. Suma intervalos entre fichajes y ausencias aprobadas; no conoce el horario contractual, pausas, festivos por sede ni reglas CCNL. No calcula nómina ni horas extra y no es un archivo validado para importar. Reconcílialo antes de usarlo.',
  'report.month': 'Mes',
  'report.prepare': 'Preparar el informe',
  'report.loading': 'Preparando…',
  'report.empty': 'Ningún fichaje ni ausencia en este mes.',
  'report.ready': '{employees} empleados · {lines} jornadas',
  'report.anomalies': '{n} anomalías que revisar antes de enviar el archivo (ver la columna «Anomalías»).',
  'report.detail': 'Descargar detalle diario (CSV)',
  'report.summary': 'Descargar resumen por empleado (CSV)',
  'report.dayUnit': 'd',
  'report.allocationRequired': 'Exportación bloqueada: {employee}, {code}, del {from} al {to}, cantidad aprobada {quantity}. No se puede determinar el reparto diario con el calendario actual (lun–vie, sin festivos nacionales). Acordar el reparto con el consulente; no modificar la solicitud histórica para ajustarla al calendario.',
  'report.col.number': 'Matrícula',
  'report.col.cf': 'Codice fiscale',
  'report.col.employee': 'Empleado',
  'report.col.date': 'Fecha',
  'report.col.intervals': 'Entradas-Salidas',
  'report.col.hours': 'Horas (hh:mm)',
  'report.col.hundredths': 'Horas (decimal)',
  'report.col.absences': 'Ausencias',
  'report.col.anomalies': 'Anomalías',
  'report.col.days': 'Días trabajados',
  'report.col.anomalyCount': 'N.º anomalías',
  'report.anomaly.missing_out': 'falta la salida',
  'report.anomaly.missing_in': 'falta la entrada',
  'report.anomaly.long_shift': 'turno de más de 16 horas',
  'report.anomaly.corrected': 'corregido por RR. HH.',
  'report.anomaly.flagged': 'fichaje con aviso',
  'method.geo': 'Ubicación',
  'method.qr': 'QR del quiosco',
  'method.manual': 'Corrección',
  'flag.late_sync': 'Sincronizado con retraso',
  'flag.clock_skew': 'Reloj del móvil desfasado',
  'flag.sequence': 'Dos fichajes iguales seguidos',
  'flag.outside_geofence': 'Fuera de la sede',
  'flag.mock_location': 'Ubicación simulada',
  'flag.manual_correction': 'Corrección aprobada',
  'flag.hr_entry': 'Registrada por RR. HH.',
  'flag.unclosed_break': 'Salida con pausa aún abierta',

  'employees.title': 'Empleados',
  'employees.add': 'Nuevo empleado',
  'employees.onboardingInviteSent': 'Empleado creado y correo de invitación aceptado por el servicio de envío. Esto no confirma la entrega en la bandeja del trabajador.',
  'employees.onboardingInviteFailed': 'El empleado ya está creado, pero no se pudo confirmar el envío de la invitación.',
  'employees.onboardingRetryHint': 'Reintentar emitirá una invitación nueva e invalidará cualquier enlace anterior. Si el correo anterior sí llegó, ese enlace dejará de funcionar.',
  'employees.onboardingRetry': 'Emitir y enviar otra invitación',
  'employees.onboardingFinish': 'Terminar',
  'employees.onboardingProfile': 'Abrir perfil del trabajador',
  'employees.onboardingNextSteps': 'Desde el perfil puedes revisar los documentos contractuales y completar la checklist. Puedes guardar una referencia retributiva cifrada solo para HR; se publica al trabajador después de verificar su dispositivo registrado.',
  'employees.fullName': 'Nombre y apellidos',
  'employees.email': 'E-mail',
  'employees.cf': 'Codice fiscale',
  'employees.cfInvalid': 'Codice fiscale no válido.',
  'employees.number': 'Número de empleado',
  'employees.site': 'Sede',
  'employees.role': 'Rol',
  'employees.status': 'Estado',
  'employees.device': 'Dispositivo',
  'employees.deviceRegistered': 'Asociado',
  'employees.actions': 'Acciones',
  'employees.noDevice': 'Sin dispositivo',
  'employees.invite': 'Invitar',
  'employees.inviteTitle': 'Invitación para {name}',
  'employees.inviteBody':
    'Enviaremos el enlace a {email}. Vale 7 días y solo funciona con esa dirección. También puedes compartirlo a mano (WhatsApp, SMS, QR impreso).',
  'employees.inviteSend': 'Enviar invitación por e-mail',
  'employees.inviteLinkOnly': 'Solo enlace, para compartir a mano',
  'employees.inviteEmail': 'Enviar por e-mail',
  'employees.inviteEmailed': 'E-mail enviado a {email}. El enlace de arriba es el mismo.',
  'employees.inviteEmailFailed': 'El e-mail no ha salido. Comparte el enlace a mano o vuelve a intentarlo en un rato.',
  'employees.inviteNewLinkHint': 'Crea un enlace nuevo: el anterior deja de funcionar.',
  'employees.inviteNoEmail': 'Este empleado no tiene dirección de e-mail: sin ella no puede activar la cuenta. Añádela en sus datos.',
  'employees.empty': 'Todavía no hay empleados. Añade el primero.',

  'import.button': 'Importar CSV',
  'import.title': 'Importar empleados desde CSV',
  'import.body': 'Exporta la plantilla desde el programa de nóminas o Excel en CSV. Columnas reconocidas: nombre completo (o nombre y apellidos), e-mail, codice fiscale, matrícula, sede. El archivo se lee en este navegador y no se guarda nada hasta que confirmes.',
  'import.template': 'Descargar la plantilla',
  'import.file': 'Archivo CSV',
  'import.missingName': 'El archivo no tiene columna de nombre: necesita «Nombre completo» o «Nombre» y «Apellidos».',
  'import.empty': 'El archivo no tiene filas que importar.',
  'import.summary': '{ready} para importar · {exists} ya existentes · {errors} por corregir',
  'import.line': 'Fila',
  'import.status.ready': 'Para importar',
  'import.status.exists': 'Ya existe',
  'import.status.error': 'Por corregir',
  'import.existing': 'ya registrado como {name}',
  'import.noEmail': 'sin e-mail: no podrá recibir la invitación',
  'import.issue.name_missing': 'falta el nombre',
  'import.issue.name_too_long': 'nombre demasiado largo',
  'import.issue.email_invalid': 'e-mail no válido',
  'import.issue.cf_invalid': 'codice fiscale no válido',
  'import.issue.number_too_long': 'matrícula demasiado larga',
  'import.issue.site_unknown': 'sede no encontrada',
  'import.issue.duplicate_in_file': 'repite la fila {line}',
  'import.skipped': 'Las filas por corregir no se importarán: corrígelas e importa de nuevo el archivo.',
  'import.tooMany': 'Como máximo {max} empleados por archivo: divídelo.',
  'import.submit': 'Importar {n} empleados',
  'import.done': 'Importados {n} empleados. Ya puedes invitarlos desde la lista.',
  'import.rowFailed': 'Fila {line}: {reason}. No se ha importado ningún empleado.',
  'import.reason.email_taken': 'e-mail ya usado por otro empleado',
  'import.reason.cf_taken': 'codice fiscale ya presente en la empresa',
  'import.reason.invalid': 'valor no válido',
  'import.reason.site': 'sede no válida',
  'import.reason.other': 'error inesperado',
  "roles.guideTitle": "Roles y responsables: quién puede hacer qué",
  "roles.guideBody": "En Gestionar → Datos eliges el rol de acceso y el responsable directo. En Gestionar → Datos laborales registras mansione, categoría, nivel y CCNL con vigencia: no conceden permisos. En Organización configuras departamentos, subunidades, cadenas de responsables y delegaciones temporales. Cada persona tiene un solo responsable directo. El acceso a equipos subordinados requiere el ámbito ampliado explícito; no habilita documentos ni datos contractuales HR.",
  "roles.scope.employee": "Usa la app para sus propios datos, fichajes, solicitudes y documentos. Sin acceso al portal de empresa.",
  "roles.scope.manager": "Accede a fichajes, informes y solicitudes del equipo asignado. Puede aprobar solicitudes del equipo, nunca las propias. No accede a las páginas de RR. HH. de empleados, nóminas, sedes o solicitudes RGPD.",
  "roles.scope.hr_admin": "Gestiona empleados, fichajes, solicitudes, envíos cifrados de documentos, sedes y solicitudes RGPD de la empresa. Puede nombrar responsables; solo el titular cambia los roles RR. HH. y Titular.",
  "roles.scope.company_owner": "Tiene las funciones de RR. HH. y puede asignar o retirar los roles RR. HH. y Titular. Debe quedar al menos un titular activo.",
  "roles.confirmTitle": "¿Cambiar el rol de {name}: {from} → {to}?",
  "roles.confirmBody": "Este cambio modifica los permisos de acceso. Se guarda por separado de los demás datos del formulario. Los permisos también requieren un perfil activo.",
  "roles.releasesTeam": "{n} personas quedarán sin este responsable: {names}. Tendrás que asignarles otro; RR. HH. puede seguir gestionando sus solicitudes.",
  "roles.selfChange": "Estás cambiando tu propio rol: podrías perder acceso a partes del portal.",
  "roles.confirm": "Confirmar cambio de rol",
  'role.employee': 'Empleado',
  'role.manager': 'Responsable',
  'role.hr_admin': 'RR. HH.',
  'role.company_owner': 'Titular',
  'status.invited': 'Invitado',
  'status.active': 'Activo',
  'status.suspended': 'Suspendido',
  'status.erased': 'Suprimido',

  'sites.title': 'Sedes y quioscos',
  'sites.add': 'Nueva sede',
  'sites.empty': 'No hay sedes configuradas. Añade una para empezar.',
  'sites.noKiosks': 'No hay quioscos configurados para esta sede.',
  'sites.retrySites': 'Reintentar la carga de sedes',
  'sites.retryKiosks': 'Reintentar la carga de quioscos',
  'sites.name': 'Nombre',
  'sites.address': 'Dirección',
  'sites.latitude': 'Latitud',
  'sites.longitude': 'Longitud',
  'sites.radius': 'Radio (m)',
  'sites.geo': 'Fichaje con ubicación',
  'sites.geoWarning':
    'Actívalo solo tras el acuerdo sindical o la autorización de la Inspección (art. 4 L. 300/1970). Hasta entonces se ficha con el QR del quiosco.',
  'sites.qrOnly': 'Solo QR',
  'sites.geoOn': 'Ubicación + QR',
  'sites.kiosks': 'Quioscos',
  'sites.addKiosk': 'Nuevo quiosco',
  'sites.kioskName': 'Nombre del quiosco (p. ej. Entrada)',
  'sites.pairingTitle': 'Vincula la tablet',
  'sites.pairingBody': 'En la tablet de la entrada abre {url} e introduce este código en 10 minutos:',
  'sites.revokeKiosk': 'Desactivar',
  'sites.revokeTitle': '¿Desactivar el quiosco {name}?',
  'sites.revokeWarning': 'El quiosco {name} dejará de registrar fichajes QR. Para volver a fichar desde esta tableta habrá que vincular un quiosco nuevo.',
  'sites.pairingMissing': 'Se creó el quiosco, pero no llegó el código de vinculación. No vuelvas a intentarlo: contacta con soporte.',
  'kioskStatus.pairing': 'Por vincular',
  'kioskStatus.active': 'Activo',
  'kioskStatus.revoked': 'Desactivado',

  'kiosk.pairTitle': 'Vincula este quiosco',
  'kiosk.pairBody': 'Introduce el código que muestra el portal (Sedes y quioscos → Nuevo quiosco).',
  'kiosk.code': 'Código de vinculación',
  'kiosk.pair': 'Vincular',
  'kiosk.scan': 'Escanea el código con la app Fide para fichar',
  'kiosk.refresh': 'Nuevo código en {s} s',
  'kiosk.unpair': 'Desvincular quiosco',
  'kiosk.clockWarning': 'El reloj de este dispositivo está desfasado {s} s: corrígelo o los fichajes serán rechazados.',

  'payroll.title': 'Documentos del personal',
  'comp.title': 'Referencias retributivas',
  'comp.intro': 'Se cifran en el navegador y se leen en un móvil HR autorizado y en el móvil del trabajador. Fide no guarda una clave de recuperación.',
  'comp.employee': 'Trabajador', 'comp.choose': 'Selecciona un trabajador', 'comp.label': 'Descripción de la referencia',
  'comp.amount': 'Importe', 'comp.currency': 'Moneda', 'comp.frequency': 'Periodicidad', 'comp.frequency.hourly': 'Por hora',
  'comp.frequency.monthly': 'Mensual', 'comp.frequency.annual': 'Anual', 'comp.frequency.one_time': 'Único',
  'comp.effective': 'Vigente desde', 'comp.replaces': 'Corrige la referencia', 'comp.new': 'Nueva referencia',
  'comp.save': 'Cifrar y guardar', 'comp.saving': 'Cifrando y guardando…', 'comp.saved': 'Referencia guardada cifrada.',
  'comp.empty': 'No hay referencias registradas.', 'comp.history': 'Historial cifrado', 'comp.privacy': 'El importe y la descripción en claro no se envían a la base de datos: solo se guarda el contenido cifrado. Las referencias no son nóminas ni calculan o conceden derechos automáticamente.',
  'comp.keys': 'Claves de móviles autorizados', 'comp.verify': 'He comparado este código con el móvil Fide indicado.',
  'comp.keyMismatch': 'La huella no coincide con las claves públicas. Se bloquea el guardado.',
  'comp.keyChanged': 'La clave del móvil ha cambiado: compara el nuevo código en el móvil antes de continuar.',
  'comp.noKey': 'Falta una clave móvil activa del trabajador o del usuario HR actual.', 'comp.error': 'No se pudo completar la operación. Comprueba las claves y la conexión.',
  'comp.conflict': 'Otra sesión ya corrigió esta referencia. Se actualizó el historial; selecciona la versión vigente y vuelve a intentarlo.',
  'comp.saveDraft': 'Guardar borrador cifrado', 'comp.draftSaved': 'Borrador cifrado guardado para los móviles HR.',
  'comp.draftHint': 'El borrador se cifra solo para los móviles HR verificados. El trabajador no puede verlo hasta que un móvil HR lo publique para su clave activa.',
  'comp.drafts': 'Borradores cifrados', 'comp.draftsEmpty': 'No hay borradores pendientes.',
  'comp.draftExpires': 'Caduca el {date}', 'comp.draftsPublish': 'Abre Referencias retributivas en un móvil HR autorizado para revisar y publicar un borrador.',
  'comp.discardDraft': 'Descartar borrador', 'comp.discardDraftConfirm': '¿Descartar definitivamente este borrador cifrado?', 'comp.draftDiscarded': 'Borrador cifrado descartado.',
  'comp.read': 'Solicitar lectura en el portal', 'comp.selectRead': 'Selecciona las referencias que quieres leer', 'comp.qrTitle': 'Escanea con un móvil HR autorizado',
  'comp.qrHint': 'Abre Referencias retributivas en la app Fide HR y escanea este código. Compara el código de seguridad que también aparece en el móvil.',
  'comp.fingerprint': 'Código de verificación: {code}', 'comp.waiting': 'Esperando la aprobación del móvil HR…',
  'comp.cancel': 'Cancelar solicitud', 'comp.readDone': 'Referencias abiertas tras la aprobación móvil. Cierra esta vista para borrar la copia temporal.',
  'comp.expired': 'La solicitud ha caducado. Inicia otra.', 'comp.readError': 'El móvil no puede abrir estas referencias o la solicitud ha caducado.',
  'comp.close': 'Cerrar y borrar',
  'comp.maxRead': 'Puedes solicitar la lectura de hasta 25 referencias por vez.',
  'comp.maxRecipients': 'Se permiten hasta 100 teléfonos autorizados por referencia.',
  'payroll.privacy':
    'El PDF se divide y se cifra en este navegador. Fide solo recibe archivos cifrados que únicamente puede abrir el móvil del empleado.',
  'payroll.kind': 'Tipo',
  'kind.cedolino': 'Nómina (cedolino)',
  'kind.contract': 'Contrato / carta de contratación',
  'kind.contract_change': 'Cambio contractual',
  'kind.training_certificate': 'Certificado de formación',
  'kind.hr_notice': 'Comunicación de RR. HH.',
  'kind.tfr': 'TFR / liquidación final',
  'kind.cu': 'Certificazione Unica',
  'kind.other': 'Otro documento',
  'payroll.period': 'Mes',
  'payroll.reference.month': 'Mes de la nómina',
  'payroll.reference.taxYear': 'Año fiscal de referencia',
  'payroll.reference.date': 'Fecha de referencia',
  'payroll.docTitle': 'Título',
  'payroll.file': 'PDF acumulado (Zucchetti, TeamSystem…)',
  'payroll.fileDocument': 'PDF del documento (puede incluir páginas de varias personas)',
  'payroll.analyze': 'Analizar',
  'payroll.analyzing': 'Leyendo el PDF…',
  'payroll.pages': '{n} páginas',
  'payroll.matched': 'Listos para enviar',
  'payroll.issues': 'Por revisar',
  'payroll.noKey': 'Sin dispositivo activo: todavía no puede recibir documentos cifrados.',
  'payroll.issue.unassigned': 'Página {page}: ningún empleado reconocido.',
  'payroll.issue.ambiguous': 'Página {page}: contiene varios empleados.',
  'payroll.issue.identity_conflict': 'Página {page}: el codice fiscale y el nombre corresponden a empleados distintos.',
  'payroll.issue.unknown_employee': 'Página {page}: codice fiscale que no está en la empresa.',
  'payroll.publish': 'Cifrar y publicar {n} documentos',
  'payroll.encrypting': 'Cifrando {done}/{total}…',
  'payroll.uploading': 'Subiendo {done}/{total}…',
  'payroll.publishing': 'Publicando…',
  'payroll.done': 'Publicados {n} documentos: los empleados los encuentran en la app Fide, en Documentos.',
  'payroll.new': 'Nuevo envío',
  'payroll.recipients': 'Destinatarios',
  'payroll.pagesCol': 'Páginas',
  'payroll.continuation': 'páginas sin codice fiscale añadidas al empleado anterior: {pages}',
  'payroll.manual': 'asignadas a mano: {pages}',
  'payroll.state.ready': 'Listo',
  'payroll.state.reissue': 'Reemisión: móvil nuevo',
  'payroll.state.delivered': 'Ya entregado',
  'payroll.state.no_key': 'Sin dispositivo activo',
  'payroll.state.key_changed': 'Dispositivo cambiado',
  'payroll.state.key_mismatch': 'Código de seguridad incoherente: no enviar',
  'payroll.firstUse': 'primera vez',
  'payroll.firstUseHint': 'Primer documento cifrado para este móvil desde este navegador. Puedes comparar el código de seguridad con la app del empleado (Mis datos → Este móvil).',
  'payroll.sendAgain': 'Enviar de nuevo (lo sustituye)',
  'payroll.verify': 'Verificar',
  'payroll.assign': 'Asignar a',
  'payroll.dontSend': '— No enviar —',
  'payroll.skippedPages': '{n} páginas no se enviarán.',
  'payroll.verifyTitle': 'Verifica el móvil de {name}',
  'payroll.verifyBody': 'El móvil de este empleado ha cambiado. Pídele que abra Fide → Mis datos → Este móvil y te lea el código de seguridad. Confirma solo si coincide con el actual; si no, no envíes y contacta con el soporte de Fide.',
  'payroll.verifyPrevious': 'Código de seguridad anterior',
  'payroll.verifyCurrent': 'Código de seguridad actual',
  'payroll.verifyConfirm': 'El código coincide',
  'payroll.trustUnavailable': 'Este navegador no puede guardar los códigos de seguridad verificados (¿navegación privada?): cada móvil se tratará como nuevo.',
  'payroll.encryptedPdf': 'El PDF está protegido con contraseña. Expórtalo sin protección desde el programa de nóminas.',
  'payroll.notPdf': 'El archivo no es un PDF legible.',
  'payroll.cryptoBroken': 'Este navegador no supera la verificación criptográfica: actualiza Chrome, Edge, Firefox o Safari.',
  'payroll.retry': 'Reintentar',
  'payroll.reset': 'Nuevo PDF',
  'payroll.nothingToSend': 'Ningún documento que enviar.',
  'payroll.history': 'Historial de envíos',
  'payroll.historyEmpty': 'Ningún envío todavía.',
  'payroll.historyRange': 'Envíos {from}–{to} de {total}',
  'payroll.historyPagination': 'Páginas de envíos',
  'payroll.documentsRange': 'Documentos {from}–{to} de {total}',
  'payroll.documentsPagination': 'Páginas de documentos',
  'payroll.noDocuments': 'No hay documentos en este envío.',
  'payroll.opened': '{opened}/{total} abiertos',
  'payroll.draft': 'No publicado',

  'requests.title': 'Solicitudes',
  'requests.leave': 'Vacaciones y permisos',
  'requests.corrections': 'Fichajes olvidados',
  'requests.overtime': 'Horas extraordinarias y Bolsa de horas',
  'requests.smartWorking': 'Teletrabajo (smart working)',
  'requests.compensationType': 'Destino',
  'requests.compensation.payout': 'Liquidación en nómina',
  'requests.compensation.banca_ore': 'Bolsa de horas (Descanso compensatorio)',
  'requests.empty': 'No hay solicitudes pendientes.',
  'requests.approve': 'Aprobar',
  'requests.reject': 'Rechazar',
  'requests.verifyProtocol': 'Comprobar PUC',
  'requests.verifyProtocolTitle': 'Comprobar el protocolo de {name}',
  'requests.verifyProtocolHint': 'Comprueba este PUC en el servicio del INPS para empleadores. Fide registra tu confirmación, pero no consulta el INPS.',
  'requests.verifyProtocolConfirm': 'Confirmo que he comprobado el PUC en el servicio del INPS.',
  'requests.sickAwaitingHr': 'Pendiente de comprobación por RR. HH.',
  'requests.sickVerified': 'PUC comprobado por RR. HH.',
  'requests.sickLegacy': 'No consta comprobación del PUC en Fide',
  'requests.amendSick': 'Corregir/ampliar',
  'requests.amendSickTitle': 'Corregir la baja de {name}',
  'requests.sickChangeKind': 'Acción',
  'requests.sickExtension': 'Ampliación',
  'requests.sickCorrection': 'Corrección',
  'requests.periodFrom': 'Desde',
  'requests.periodTo': 'Hasta',
  'requests.amendReason': 'Motivo del cambio',
  'requests.amendSickHint': 'La solicitud original permanece en el historial. El nuevo periodo vuelve a quedar pendiente de comprobar por RR. HH.',
  'requests.period': 'Periodo',
  'requests.quantity': 'Cantidad',
  'requests.reason': 'Motivo',

  'audit.title': 'Registro de actividad',
  'audit.when': 'Cuándo',
  'audit.what': 'Qué',
  'audit.actor': 'Quién',
  'audit.subject': 'Empleado',
  'audit.actorUnknown': 'Usuario no disponible',
  'audit.actorSystem': 'Sistema',
  'audit.empty': 'Sin actividad registrada.',
  'audit.note': 'Registro administrativo y de seguridad de los últimos 90 días: quién actuó y qué campos cambió, sin valores personales. Los cambios de idioma no se registran.',
  'audit.pagination': 'Paginación del registro de actividad',
  'audit.results': 'Eventos {from}–{to} de {total}',
  'audit.table.companies': 'Datos de la empresa',
  'audit.table.sites': 'Centros de trabajo',
  'audit.table.members': 'Fichas y roles de empleados',
  'audit.table.member_identities': 'Identidades de empleados',
  'audit.table.invitations': 'Invitaciones',
  'audit.table.kiosk_devices': 'Quioscos',
  'audit.table.device_keys': 'Dispositivos de empleados',
  'audit.table.punch_corrections': 'Correcciones de fichajes',
  'audit.table.payroll_batches': 'Envíos de documentos',
  'audit.table.documents': 'Documentos del personal',
  'audit.table.leave_types': 'Tipos de ausencia',
  'audit.table.leave_balances': 'Saldos de vacaciones y permisos',
  'audit.table.leave_requests': 'Solicitudes de ausencia',
  'audit.table.gdpr_requests': 'Solicitudes de privacidad',
  'audit.table.company_announcements': 'Avisos de la empresa',
  'audit.table.employment_terms': 'Condiciones del contrato',
  'audit.table.other': 'Otro registro de empresa',
  'audit.field.status': 'estado',
  'audit.field.revoked_at': 'fecha de revocación',
  'audit.field.preferred_language': 'idioma preferido',
  'audit.field.geo_enabled': 'geolocalización activada',
  'audit.field.latitude': 'latitud del centro',
  'audit.field.longitude': 'longitud del centro',
  'audit.field.manager_member_id': 'responsable asignado',
  'audit.field.site_id': 'centro asignado',
  'audit.field.first_opened_at': 'primera apertura del documento',
  'audit.field.published_at': 'fecha de publicación',
  'audit.field.decided_at': 'fecha de decisión',
  'audit.field.decided_by': 'autor de la decisión',
  'audit.field.auth_user_id': 'cuenta vinculada',
  'audit.field.other': 'otros campos modificados',
  'op.INSERT': 'creado',
  'op.UPDATE': 'modificado',
  'op.DELETE': 'eliminado',

  'settings.title': 'Ajustes',
  'settings.company': 'Datos de la empresa',
  'settings.passkeys': 'Passkeys',
  'settings.passkeysBody':
    'Una passkey te deja entrar con el desbloqueo de este dispositivo (PIN, contraseña o el método que ya usas), sin códigos por e-mail. La comprobación la hace el dispositivo: Fide no recibe nada.',
  'settings.addPasskey': 'Registrar una passkey en este dispositivo',
  'settings.noPasskeys': 'No hay passkeys registradas.',
  'settings.passkeyAdded': 'Passkey registrada.',
  'settings.saved': 'Guardado.',

  'error.signupNotAllowed': 'Durante el piloto el registro es por invitación. Escríbenos para habilitar tu empresa.',
  'error.emailNotConfirmed': 'Confirma antes tu dirección de e-mail.',
  'error.forbidden': 'No tienes permiso para esta operación.',
  'error.notAuthenticated': 'Sesión caducada: vuelve a entrar.',
  'error.memberNotInvitable': 'El empleado ya ha activado su cuenta.',
  'error.memberEmailMissing': 'Añade antes el e-mail del empleado.',
  'error.lastOwner': 'La empresa necesita al menos un titular.',
  'error.deviceKeyNotActive': 'Un empleado ha cambiado de móvil mientras tanto: vuelve a analizar el PDF.',
  'error.uploadIncomplete': 'Algunos archivos no se han subido: inténtalo de nuevo.',
  'error.supersedesInvalid': 'El documento que se iba a sustituir ya no es válido: vuelve a analizar el PDF.',
  'error.notDraft': 'Este envío ya se ha publicado.',
  'error.pairingCodeInvalid': 'Código no válido o caducado.',
  'error.notPending': 'Solicitud ya gestionada.',
  'error.duplicate': 'Ya existe.',
  'error.invalidValue': 'Uno de los valores no es válido.',
  'error.generic': 'Algo ha ido mal. Inténtalo de nuevo.',
  'error.idempotencyConflict': 'Los datos de este alta cambiaron durante el reintento. Revisa la ficha antes de volver a enviarla.',

  // Block 1: lifecycle, HR entries, withdrawal, GDPR inbox
  'error.terminationDateRequired': 'Indica el último día de trabajo.',
  'error.terminationDateInvalid': 'La fecha de baja no puede ser futura ni de hace más de un año: regístrala a partir del último día de trabajo.',
  'error.emailLocked': 'El e-mail es el acceso del empleado: solo se puede corregir mientras no haya activado la cuenta.',
  'error.managerInvalid': 'Elige como responsable a otra persona activa de la misma empresa.',
  'error.memberErased': 'Los datos de esta persona se han borrado.',
  'error.selfEntry': 'No puedes registrar por ti mismo: debe hacerlo otra persona de RR. HH. o el titular.',
  'error.memberNotActive': 'Esta persona no está activa en esa fecha.',
  'error.reasonRequired': 'Escribe el motivo (al menos 3 caracteres).',
  'error.tsInFuture': 'No se puede registrar una hora futura.',
  'error.protocolRequired': 'Para la baja por enfermedad hace falta el número de protocolo del certificado INPS.',
  'error.leaveTypeInactive': 'Este tipo de ausencia no está activo.',
  'error.alreadyWithdrawn': 'El documento ya se ha retirado.',
  'error.answerRequired': 'Escribe la respuesta para el empleado.',
  'error.alreadyResolved': 'Solicitud ya cerrada.',
  'error.alreadyExtended': 'La prórroga solo se puede usar una vez.',
  'error.deadlinePassed': 'El primer mes ya ha pasado: ya no se puede prorrogar, responde enseguida.',
  'error.memberNotTerminated': 'Este borrado solo es posible para ex empleados.',
  'nav.privacy': 'Privacidad (RGPD)',
  'status.terminated': 'De baja',
  'employees.manage': 'Gestionar',
  'member.tab.data': 'Datos',
  'member.tab.status': 'Estado y móvil',
  'member.tab.entries': 'Registrar en su nombre',
  'member.emailInvitedHint': 'Puedes corregirlo mientras no active la cuenta: las invitaciones ya enviadas dejan de valer.',
  'member.emailLockedHint': 'Es la dirección con la que entra en la app: no se puede cambiar desde aquí.',
  'member.cfChangeHint': 'El codice fiscale decide qué páginas de las nóminas recibe: revísalo bien.',
  'member.manager': 'Responsable de solicitudes',
  'member.language': 'Idioma de la app',
  'member.saved': 'Datos guardados.',
  'member.statusTitle': 'Estado',
  'member.terminatedInfo': 'Último día: {day}. Puede ver sus documentos hasta el {until}.',
  'member.suspendedSince': 'Suspendido desde el {when}.',
  'member.selfNote': 'No puedes cambiar tu propio estado ni registrar por ti mismo.',
  'member.invitedNote': 'Aún no ha activado la cuenta: por ahora solo puedes invitarle o corregir sus datos.',
  'member.suspend': 'Suspender',
  'member.reactivate': 'Reactivar',
  'member.undoTermination': 'Anular la baja',
  'member.terminate': 'Registrar la baja',
  'member.suspendExplain': 'Bloquea al momento todo el acceso: no puede fichar, ver documentos ni hacer solicitudes. Se puede deshacer en cualquier momento. Los fichajes hechos antes, aún en cola en el móvil, siguen siendo válidos.',
  'member.terminateExplain': 'Desde ya no puede fichar ni hacer solicitudes; las vacaciones pedidas para después del último día se anulan. Durante 12 meses aún puede ver y descargar sus documentos, y tú puedes enviarle la nómina final, el TFR y la CU.',
  'member.reactivateExplain': 'Vuelve a tener acceso completo: fichajes, solicitudes y documentos.',
  'member.suspendConfirm': 'Suspender el acceso',
  'member.terminateConfirm': 'Registrar la baja',
  'member.reactivateConfirm': 'Reactivar',
  'member.lastDay': 'Último día de trabajo',
  'member.lastDayHint': 'Podrá ver sus documentos hasta el {until}.',
  'member.statusDone': 'Estado actualizado: {status}.',
  'member.cancelledRequests': 'Anuladas {n} solicitudes de ausencia posteriores al último día.',
  'member.reportsWarning': '{n} personas siguen teniendo a esta persona como responsable: asígnales uno nuevo en sus datos.',
  'member.phoneTitle': 'Móvil',
  'member.phoneSince': 'activo desde el {when}',
  'member.revokePhone': 'Revocar móvil',
  'member.phoneRevoked': 'Móvil revocado. En el próximo acceso la app pedirá configurar de nuevo el móvil.',
  'member.revokeExplain': 'Úsalo si el móvil se ha perdido, lo han robado o lo ha cambiado. Desde ya ese móvil no puede fichar ni abrir documentos nuevos. El empleado configura la app en el móvil nuevo y hay que reenviar las nóminas ya enviadas (te lo indica la página Nóminas).',
  'member.revokeReason': 'Motivo',
  'member.revokeReason.lost': 'Perdido',
  'member.revokeReason.stolen': 'Robado',
  'member.revokeReason.replaced': 'Cambiado por otro móvil',
  'member.revokeReason.other': 'Otro',
  'member.revokeConfirm': 'Revocar este móvil',
  'member.entriesExplain': 'Para quien no usa su propio móvil o para corregir un día. En la app del empleado aparece «registrado por RR. HH.» con el motivo, y puede impugnarlo.',
  'member.recordPunch': 'Registrar fichaje',
  'member.punchType': 'Tipo',
  'member.when': 'Fecha y hora',
  'member.reason': 'Motivo',
  'member.punchReasonPlaceholder': 'Ej. trabaja sin smartphone, confirmado por el capo turno',
  'member.punchRecorded': 'Fichaje registrado.',
  'member.recordLeave': 'Registrar ausencia',
  'member.leaveType': 'Tipo de ausencia',
  'member.from': 'Desde',
  'member.to': 'Hasta',
  'member.quantityDays': 'Días',
  'member.quantityHours': 'Horas',
  'member.protocol': 'Protocolo del certificado INPS',
  'member.leaveReasonPlaceholder': 'Ej. certificado recibido del médico, vacaciones acordadas',
  'member.leaveRecorded': 'Ausencia registrada.',
  'member.sickDurationAuto': 'La duración se calcula automáticamente en días naturales a partir del periodo.',
  'payroll.showDocuments': 'Documentos',
  'payroll.hideDocuments': 'Ocultar',
  'payroll.withdrawnCount': '{n} retirados',
  'payroll.withdrawn': 'Retirado',
  'payroll.openedOn': 'Abierto el {when}',
  'payroll.notOpened': 'Aún no abierto',
  'payroll.withdraw': 'Retirar',
  'payroll.withdrawTitle': 'Retirar el documento de {name}',
  'payroll.withdrawExplain': '«{title}» desaparece de la app del empleado y se destruye la clave que lo abre: nadie podrá descifrarlo ya. Úsalo si se envió a la persona equivocada o por error.',
  'payroll.withdrawAlreadyOpened': 'El destinatario ya lo ha abierto.',
  'payroll.withdrawPlaceholder': 'Ej. enviado a la persona equivocada',
  'payroll.withdrawConfirm': 'Retirar el documento',
  'payroll.withdrawDone': 'Documento retirado.',
  'payroll.withdrawBreach': 'El destinatario ya lo había descargado: puede haberlo leído. Si era la persona equivocada es una violación de datos personales: la empresa debe evaluarla y, si hay riesgo para el interesado, notificarla al Garante en 72 horas (art. 33 RGPD). Anótala en el registro de violaciones.',
  'payroll.withdrawNotDownloaded': 'Aún no se había descargado: nadie lo ha leído.',
  'payroll.withdrawFileLater': 'El archivo cifrado no se ha borrado ahora; sin la clave es ilegible de todas formas.',
  'payroll.withdrawResend': 'Para enviarlo a la persona correcta, vuelve a subir el PDF y asigna la página a mano.',
  'privacy.title': 'Solicitudes de privacidad (RGPD)',
  'privacy.intro': 'Los empleados (y los ex empleados, durante 12 meses) hacen estas solicitudes desde la app. La ley da un mes para responder, prorrogable una vez dos meses explicando el motivo (art. 12 RGPD). El empleado lee tu respuesta en la app.',
  'privacy.empty': 'Ninguna solicitud.',
  'privacy.emptyOpen': 'No hay solicitudes pendientes.',
  'privacy.emptyClosed': 'No hay solicitudes en el historial.',
  'privacy.tabOpen': 'Por gestionar',
  'privacy.tabClosed': 'Historial',
  'privacy.results': 'Solicitudes {from}–{to} de {total}',
  'privacy.pagination': 'Páginas de solicitudes de privacidad',
  'privacy.countUnavailable': 'No disponible el recuento de solicitudes de privacidad',
  'privacy.received': 'Recibida',
  'privacy.kind': 'Tipo',
  'privacy.due': 'Plazo',
  'privacy.overdue': 'Vencida',
  'privacy.answer': 'Responder',
  'privacy.view': 'Ver',
  'privacy.openCount': '{n} solicitudes abiertas',
  'privacy.kind.access': 'Acceso a los datos',
  'privacy.kind.portability': 'Portabilidad',
  'privacy.kind.erasure': 'Supresión',
  'privacy.kind.rectification': 'Rectificación',
  'privacy.kind.objection': 'Oposición',
  'privacy.status.pending': 'Por gestionar',
  'privacy.status.in_progress': 'En curso',
  'privacy.status.completed': 'Atendida',
  'privacy.status.rejected': 'Rechazada',
  'privacy.panelTitle': '{kind} · {name}',
  'privacy.receivedOn': 'Recibida el {when}',
  'privacy.dueOn': 'responder antes del {when}',
  'privacy.extended': 'prorrogada',
  'privacy.extensionNote': 'Motivo de la prórroga: {note}',
  'privacy.guide.access': 'El empleado puede descargar él mismo todos los datos que guarda Fide (app → Privacidad → Exportar). En la respuesta confírmalo y añade lo que la empresa guarda fuera de Fide (expediente en papel, programa de nóminas).',
  'privacy.guide.portability': 'La exportación desde la app (JSON) ya está en formato portable. Confírmalo en la respuesta e indica los datos que haya en otros sistemas.',
  'privacy.guide.erasure': 'Los fichajes, las nóminas y los documentos de la relación laboral se deben conservar por ley (art. 17.3.b RGPD; Libro Unico del Lavoro, 5 años): normalmente se responde explicándolo. A un ex empleado le puedes borrar ya lo que no es obligatorio (claves del móvil, avisos).',
  'privacy.guide.rectification': 'Corrige los datos en la página Empleados (Gestionar → Datos) y confirma en la respuesta qué has cambiado.',
  'privacy.guide.objection': 'Valora si el tratamiento se basa en el interés legítimo: en ese caso hay que interrumpirlo salvo motivos prevalentes, que se explican en la respuesta (art. 21 RGPD).',
  'privacy.answerLabel': 'Respuesta al empleado',
  'privacy.answerHint': 'Hace falta una respuesta clara: qué has hecho o por qué no es posible, y el derecho a reclamar ante el Garante.',
  'privacy.useTemplate': 'Usar el texto sobre la conservación obligatoria',
  'privacy.template.erasureRetention': 'Hemos recibido tu solicitud de supresión. Los fichajes, las nóminas y los demás documentos de la relación laboral deben conservarse por obligación legal (art. 17, apdo. 3, letra b, RGPD; Libro Unico del Lavoro, 5 años) y no se pueden borrar ahora: se borrarán al vencer los plazos. Los demás datos no necesarios se han eliminado. Puedes presentar una reclamación ante el Garante per la protezione dei dati personali.',
  'privacy.takeOn': 'Marcar en curso',
  'privacy.reject': 'Rechazar',
  'privacy.complete': 'Marcar como atendida',
  'privacy.eraseFormerExplain': 'Ex empleado: puedes borrar ya lo que no es obligatorio conservar. Se revocan las claves de su móvil (sus documentos en Fide ya no se podrán abrir) y se eliminan los avisos. La solicitud se cierra con la respuesta escrita arriba.',
  'privacy.eraseFormer': 'Borrar los datos no obligatorios y cerrar',
  'privacy.extendExplain': '¿Solicitud compleja? Puedes prorrogar dos meses, una sola vez y dentro del primer mes. El empleado verá el motivo.',
  'privacy.extendPlaceholder': 'Motivo de la prórroga',
  'privacy.extend': 'Prorrogar 2 meses',

  // Requests: history and decision notes
  'requests.tabPending': 'Por gestionar ({n})',
  'requests.tabHistory': 'Historial',
  'requests.approveTitle': 'Aprobar la solicitud de {name}',
  'requests.rejectTitle': 'Rechazar la solicitud de {name}',
  'requests.noteRequired': 'Motivo del rechazo',
  'requests.batchApprove': 'Aprobar seleccionadas ({n})',
  'requests.batchReject': 'Rechazar seleccionadas ({n})',
  'requests.batchLimit': 'Hasta 50 solicitudes de ausencia ordinaria a la vez.',
  'requests.selectPage': 'Seleccionar todas las solicitudes ordinarias de esta página',
  'requests.selectRequest': 'Seleccionar la solicitud de {name}',
  'requests.batchApproveTitle': 'Aprobar {n} solicitudes',
  'requests.batchRejectTitle': 'Rechazar {n} solicitudes',
  'requests.batchAtomic': 'La operación es todo o nada: el servidor revalida cada solicitud y no cambia ninguna si una falla.',
  'requests.batchConfirm': 'He revisado cada solicitud seleccionada y confirmo esta decisión.',
  'requests.noteOptional': 'Nota (opcional)',
  'requests.noteHint': 'El empleado la ve en la app.',
  'requests.filterAllKinds': 'Todos los tipos',
  'requests.filterAllOutcomes': 'Todos los resultados',
  'requests.outcome': 'Resultado',
  'requests.status.approved': 'Aprobada',
  'requests.status.rejected': 'Rechazada',
  'requests.status.cancelled': 'Anulada',
  'requests.searchPerson': 'Buscar por nombre',
  'requests.historyEmpty': 'No hay solicitudes en el historial.',
  'requests.decidedBy': 'Decidido por',
  'requests.byHr': 'Registrada por RR. HH.',

  // Roles: team managers in the portal
  'member.role': 'Rol',
  'member.roleSave': 'Cambiar rol',
  'member.roleHint': 'El titular nombra a RR. HH.; RR. HH. nombra a los responsables.',
  'member.roleManagerHint': 'El equipo se asigna en el campo «Responsable» de cada empleado. Nombrar un responsable no le asigna automáticamente toda la empresa.',
  'access.managerScope': 'Solo ves tu equipo.',

  // Payslips: name cross-check
  'payroll.nameMissing': 'Nombre del empleado no encontrado en las páginas {pages}: comprueba que sean suyas.',
  'payroll.reviewTitle': 'Revisa antes de enviar',
  'payroll.reviewBody': 'Abre el enlace de cada página y comprueba que pertenece al trabajador indicado. Aunque el codice fiscale coincida, confirma visualmente el documento. La casilla se habilita al abrir el enlace; ninguna página se cifra ni publica sin confirmación.',
  'payroll.reviewOpenFirst': 'Abre primero la página del PDF para confirmar la asignación.',
  'payroll.reviewOpenPage': 'Abrir página {page} del PDF',
  'payroll.reviewPageConfirm': 'Confirmo que la página {page} pertenece a {name}.',
  'payroll.reviewGroup': '{name} · páginas {pages}',
  'payroll.reviewPageReference': 'Asignación: {match} · CF detectado: {cf}',
  'payroll.match.cf': 'codice fiscale coincidente',
  'payroll.match.continuation': 'continuación de la página anterior',
  'payroll.match.manual': 'selección manual',
  'payroll.issue.duplicate_employee': 'El codice fiscale de la página {page} está asignado a más de un empleado. Selecciona al destinatario correcto tras revisarla.',
  "member.tab.balances": "Saldos de vacaciones y permisos",
  "balances.reload": "Recargar los saldos antes de reintentar",
  "balances.year": "Año",
  "balances.type": "Tipo de ausencia",
  "balances.days": "días",
  "balances.hours": "horas",
  "balances.credited": "Acumulado / acreditado en el año",
  "balances.carried": "Arrastre del año anterior",
  "balances.sourceKind": "Origen del saldo",
  "balances.sourceConsultant": "Asesor laboral",
  "balances.sourcePayslip": "Nóminas revisadas",
  "balances.sourceOther": "Otra fuente revisada",
  "balances.asOfDate": "Saldo válido a fecha de",
  "balances.sourceReference": "Referencia / periodo (opcional)",
  "balances.referenceHint": "No incluyas diagnósticos ni datos de salud; basta con un periodo o identificador de nómina.",
  "balances.summary": "Total utilizado: {used}; pendiente: {pending}; disponible: {remaining} {unit}.",
  "balances.updated": "Actualizado: {at}",
  "balances.saved": "Saldo guardado.",
  "balances.missing": "Saldo no cargado: el trabajador verá “no cargado”, no cero.",
  "balances.noTypes": "No hay tipos de ausencia activos con saldo.",
  "balances.explain": "Carga acreditado bruto, arrastre y utilizado fuera de Fide, verificados con nóminas. Fide resta además las solicitudes aprobadas que empiezan en el año elegido: no cargues un saldo neto ni dupliques esas solicitudes en el utilizado externo. Divide por año las solicitudes que cruzan diciembre. HR actualiza lo acumulado; no hay cálculo automático por CCNL.",
  "balances.usedExternal": "Utilizado fuera de Fide (no dupliques solicitudes ya en Fide)",
  "balances.movements": "Movimientos de Fide posteriores a la fecha del saldo: {n} {unit} (incluidos en el disponible).",
  "balances.ledgerOnly": "Sin saldo declarado: solo hay movimientos registrados en Fide. Indica la fuente y la fecha del saldo antes de guardarlo.",
  "monthClose.title": "Cierre del mes",
  "monthClose.explain": "Cierra un mes después de revisarlo: no puede quedar nada pendiente. Una vez cerrado nadie puede modificarlo (solicitudes, decisiones, fichajes olvidados, horas extra); los fichajes firmados por los móviles siempre se aceptan. Reabrirlo exige un motivo, que queda en el historial.",
  "monthClose.month": "Mes",
  "monthClose.state": "Estado",
  "monthClose.open": "Abierto",
  "monthClose.closed": "Cerrado",
  "monthClose.reopened": "Reabierto",
  "monthClose.close": "Cerrar",
  "monthClose.reopen": "Reabrir",
  "monthClose.reason": "Motivo de la reapertura",
  "monthClose.confirmReopen": "Confirmar reapertura",
  "monthClose.history": "Historial de cierres",
  "monthClose.errClosed": "El mes está cerrado: RR. HH. debe reabrirlo para modificarlo.",
  "monthClose.errPending": "Hay solicitudes pendientes en este mes: decídelas antes de cerrarlo.",
  "monthClose.errNotOver": "Solo se puede cerrar un mes ya terminado.",
  "monthClose.errReason": "Escribe un motivo de al menos 10 caracteres.",
  "restricted.title": "Periodos no disponibles",
  "restricted.explain": "Fechas en las que los empleados no pueden pedir ausencias (por ejemplo un pico de trabajo o el inventario), para toda la empresa o una sede, para todos los tipos o uno. Los empleados los ven. RR. HH. puede registrar igualmente una ausencia en nombre de alguien. Malattia y Ley 104 nunca se pueden bloquear.",
  "restricted.empty": "Sin periodos.",
  "restricted.label": "Motivo visible para los empleados",
  "restricted.from": "Desde",
  "restricted.to": "Hasta",
  "restricted.site": "Sede",
  "restricted.allSites": "Todas las sedes",
  "restricted.type": "Tipo",
  "restricted.allTypes": "Todos los tipos (salvo Malattia y 104)",
  "restricted.add": "Añadir periodo",
  "restricted.delete": "Eliminar",
  "restricted.errProtected": "Malattia y Ley 104 no se pueden bloquear.",
  "restricted.errInvalid": "Revisa las fechas (máximo un año) y el motivo.",
  "restricted.errBlocked": "Las fechas caen en un periodo no disponible para solicitudes.",
  "balanceImport.button": "Importar saldos",
  "balanceImport.title": "Importar saldos del asesor laboral",
  "balanceImport.body": "Sube el archivo de saldos (CSV o Excel guardado como CSV): código fiscal, tipo (FERIE, ROL…), año, acumulado, arrastre, utilizado fuera de Fide, fecha de referencia y fuente. Fide revisa cada fila y muestra antes/después; se aplica todo o nada. Los movimientos de Fide posteriores a la fecha de referencia se siguen sumando.",
  "balanceImport.summary": "{ready} filas listas, {errors} con errores, {negative} con disponible negativo.",
  "balanceImport.person": "Persona",
  "balanceImport.type": "Tipo y año",
  "balanceImport.before": "Ahora (acumulado + arrastre − usado fuera)",
  "balanceImport.after": "Del archivo",
  "balanceImport.available": "Disponible después",
  "balanceImport.none": "Sin saldo",
  "balanceImport.reconcileHint": "El disponible resta las solicitudes aprobadas en Fide en el año. Un valor negativo indica una diferencia que conviene revisar con el asesor antes de importar.",
  "balanceImport.apply": "Importar {n} filas",
  "balanceImport.done": "{n} saldos importados.",
  "balanceImport.rowFailed": "Fila {line}: {reason}. No se ha modificado ningún saldo.",
  "balanceImport.missing": "Faltan columnas obligatorias: {columns}.",
  "balanceImport.tooMany": "Máximo {max} filas por archivo.",
  "balanceImport.col.codiceFiscale": "código fiscal",
  "balanceImport.col.type": "tipo",
  "balanceImport.col.year": "año",
  "balanceImport.col.entitled": "acumulado",
  "balanceImport.col.carried": "arrastre",
  "balanceImport.col.external": "utilizado fuera",
  "balanceImport.col.asOf": "fecha de referencia",
  "balanceImport.col.source": "fuente",
  "balanceImport.col.note": "referencia",
  "balanceImport.issue.cf": "falta el código fiscal",
  "balanceImport.issue.person": "ningún empleado con este código fiscal",
  "balanceImport.issue.type": "tipo inexistente o sin saldo",
  "balanceImport.issue.year": "año no válido",
  "balanceImport.issue.number": "valor no válido",
  "balanceImport.issue.date": "fecha no válida o fuera del año",
  "balanceImport.issue.futureDate": "fecha futura",
  "balanceImport.issue.source": "fuente: consulente, cedolino o altro",
  "balanceImport.issue.note": "referencia demasiado larga",
  "balanceImport.issue.duplicate": "fila repetida",
  "balanceImport.issue.value": "valor no válido",
  "balanceImport.issue.other": "error inesperado",
  "nav.calendar": "Calendario de ausencias",
  "calendar.title": "Calendario de ausencias",
  "calendar.explainHr": "Ausencias aprobadas y pendientes de toda la empresa o de una sede, con la cobertura día a día. Las rechazadas y anuladas no aparecen.",
  "calendar.explainManager": "Ausencias aprobadas y pendientes de tu equipo, con la cobertura día a día. En Malattia y Ley 104 solo ves «Ausente», sin el motivo.",
  "calendar.previous": "Mes anterior",
  "calendar.next": "Mes siguiente",
  "calendar.site": "Sede",
  "calendar.allSites": "Todas las sedes",
  "calendar.legendLeave": "Ausencia aprobada",
  "calendar.legendPending": "Pendiente",
  "calendar.legendRemote": "Smart working",
  "calendar.empty": "No hay personas que mostrar.",
  "calendar.person": "Persona",
  "calendar.absent": "Ausentes",
  "calendar.private": "Ausente",
  "calendar.pending": "pendiente",
  "delegations.title": "Delegaciones de aprobación",
  "delegations.explain": "Durante una ausencia puedes pasar tus aprobaciones a otro responsable o a RR. HH., hasta 90 días. La delegación caduca sola, no pasa a terceros y nadie puede aprobar sus propias solicitudes.",
  "delegations.empty": "Sin delegaciones.",
  "delegations.from": "Quién delega",
  "delegations.to": "Delegado",
  "delegations.period": "Periodo",
  "delegations.state": "Estado",
  "delegations.upcoming": "Programada",
  "delegations.active": "Activa",
  "delegations.ended": "Terminada",
  "delegations.end": "Terminar",
  "delegations.start": "Desde",
  "delegations.finish": "Hasta",
  "delegations.create": "Crear delegación",
  "delegations.errPerson": "El delegado debe ser un responsable o RR. HH. activo, distinto de quien delega.",
  "delegations.errDates": "Revisa las fechas: máximo 90 días y no en el pasado.",
  "delegations.errOverlap": "Ya hay una delegación de esta persona en esas fechas.",
  "leaveTypes.title": "Tipos de ausencia",
  "leaveTypes.explain": "Nombres y reglas de los tipos que los empleados pueden solicitar. Un tipo con saldo siempre requiere la decisión de una persona. Los tipos del sistema conservan código, unidad y reglas: puedes cambiar el nombre y, si se permite, desactivarlos.",
  "leaveTypes.name": "Nombre",
  "leaveTypes.unit": "Unidad",
  "leaveTypes.rules": "Reglas",
  "leaveTypes.status": "Estado",
  "leaveTypes.system": "del sistema",
  "leaveTypes.protocol": "Protocolo INPS",
  "leaveTypes.approval": "Aprobación",
  "leaveTypes.noApproval": "Sin aprobación",
  "leaveTypes.balance": "con saldo",
  "leaveTypes.active": "Activo",
  "leaveTypes.inactive": "Desactivado",
  "leaveTypes.edit": "Editar",
  "leaveTypes.editTitle": "Editar «{name}»",
  "leaveTypes.newTitle": "Nuevo tipo de ausencia",
  "leaveTypes.new": "Añadir tipo",
  "leaveTypes.systemHint": "Tipo gestionado por Fide: solo puedes cambiar el nombre (y el estado, donde se permite).",
  "leaveTypes.code": "Código",
  "leaveTypes.tracksBalance": "Tiene saldo (vacaciones, permisos…)",
  "leaveTypes.requiresApproval": "Requiere aprobación",
  "leaveTypes.noApprovalWarning": "Sin aprobación, las solicitudes quedan aprobadas al instante. Úsalo solo para avisos que no requieren decisión.",
  "leaveTypes.errNeedsApproval": "Un tipo con saldo siempre requiere la aprobación de una persona.",
  "leaveTypes.errReserved": "Este código está reservado a un tipo del sistema.",
  "leaveTypes.errExists": "Ya existe un tipo con este código.",
  "leaveTypes.errSystem": "En los tipos del sistema solo puedes cambiar el nombre y el estado.",
  "leaveTypes.errRequired": "Malattia y Banca Ore deben seguir activos.",
  "leaveTypes.errRetired": "Las horas extra se gestionan desde sus propias solicitudes: este tipo sigue desactivado.",
  "leaveTypes.errStale": "Otra persona ha modificado el tipo. Recarga e inténtalo de nuevo.",
  "leaveTypes.errInUse": "No puedes cambiar la unidad: el tipo ya se usa en solicitudes o saldos.",
  "leaveTypes.grantedOnly": "solo habilitados",
  "leaveTypes.eligibility": "Quién puede solicitarlo",
  "leaveTypes.eligibilityEveryone": "Todos los empleados activos",
  "leaveTypes.eligibilityGranted": "Solo personas habilitadas por RR. HH.",
  "leaveTypes.errEligibilityFixed": "Malattia y Ferie son siempre para todos; Ley 104 y Smart Working, siempre solo para personas habilitadas.",
  "leaveTypes.errNotEligible": "Esta persona no está habilitada para este tipo de ausencia en las fechas elegidas.",
  "grants.title": "Habilitaciones",
  "grants.explain": "Quién puede solicitar los tipos reservados (Ley 104, Smart Working…) y en qué periodo. Terminar una habilitación no borra el historial ni las solicitudes pendientes.",
  "grants.empty": "Sin habilitaciones.",
  "grants.type": "Tipo",
  "grants.from": "Desde",
  "grants.to": "Hasta",
  "grants.toOptional": "Hasta (opcional)",
  "grants.open": "Sin fecha de fin",
  "grants.end": "Terminar",
  "grants.confirmEnd": "Confirmar fin",
  "grants.add": "Habilitar",
  "grants.self": "Tus habilitaciones las gestiona otra persona de RR. HH. o el titular.",
  "grants.privacy": "Solo persona, tipo y fechas: no indiques motivos, familiares, diagnósticos ni documentos. La habilitación solo la ven RR. HH., el titular y la persona.",
  "grants.errOverlap": "Ya hay una habilitación para esas fechas.",
  "grants.errDates": "Revisa las fechas: el fin no puede ser anterior al inicio.",
  "ledger.title": "Movimientos registrados en Fide",
  "ledger.explain": "Abonos de bolsa de horas, ajustes y anulaciones. No se modifican: un error se corrige con una anulación. Los movimientos hasta la fecha «Saldo válido a fecha de» ya están incluidos en el saldo de la fuente y no se vuelven a sumar.",
  "ledger.empty": "No hay movimientos este año.",
  "ledger.date": "Fecha",
  "ledger.kind": "Tipo",
  "ledger.quantity": "Cantidad",
  "ledger.reason": "Motivo",
  "ledger.kindBancaOre": "Horas extra a bolsa de horas",
  "ledger.kindAdjustment": "Ajuste de RR. HH.",
  "ledger.kindReversal": "Anulación",
  "ledger.included": "Ya incluido en el saldo de la fuente",
  "ledger.reverse": "Anular",
  "ledger.reverseReason": "Motivo de la anulación",
  "ledger.confirmReverse": "Confirmar anulación",
  "ledger.adjustTitle": "Nuevo ajuste",
  "ledger.quantitySigned": "Cantidad ({unit}, negativa para restar)",
  "ledger.adjust": "Registrar ajuste",
  "ledger.notReversible": "Este movimiento no se puede anular (ya anulado o es una anulación).",
  "presence.date": "Fecha (Italia)",
  "presence.resetToday": "Hoy",
  "presence.search": "Nombre, matrícula o recibo",
  "presence.siteFilter": "Sede del fichaje",
  "presence.managerFilter": "Responsable asignado",
  "presence.kindFilter": "Tipo",
  "presence.all": "Todos",
  "presence.review": "Señales técnicas",
  "presence.scope": "Resultados filtrados: {filtered} / {total} fichajes del día. Las señales no son solicitudes por aprobar; las correcciones aprobadas siguen visibles en la tabla.",
  "presence.lastIn": "Empleados en los resultados",
  "presence.lastInHint": "Personas con al menos un fichaje en los resultados filtrados; no es un contador de presentes ahora.",
  "presence.dayPunches": "Fichajes del día",
  "presence.noMatches": "Sin resultados con estos filtros.",
  "presence.pagination": "Páginas de fichajes",
  "presence.previous": "Anterior",
  "presence.next": "Siguiente",
  "presence.page": "Página {page} de {pages}",
  "requests.searchEmployee": "Nombre o matrícula",
  "requests.assignedSite": "Sede asignada",
  "requests.from": "Periodo solicitado: desde",
  "requests.to": "Periodo solicitado: hasta",
  "requests.resetFilters": "Limpiar filtros",
  "requests.filterScope": "La sede y el responsable son los asignados actualmente. Las fechas filtran el periodo de ausencia o el fichaje solicitado, incluyendo periodos superpuestos; no la fecha de decisión.",
  "requests.invalidRange": "La fecha inicial debe ser anterior o igual a la final.",
  "requests.pagination": "Páginas de solicitudes",
  "requests.results": "Filtradas: {filtered} / {total} solicitudes",
  'allocation.title': 'Reparto diario',
  'allocation.hint': 'Distribuye el total ya aprobado sin modificarlo. No se deducen días del calendario actual.',
  'allocation.add': 'Añadir día',
  'allocation.total': 'Total repartido',
  'allocation.confirm': 'Confirmo los días y el total aprobado',
  'allocation.history': 'Versiones anteriores',
  'allocation.invalid': 'Fechas, cantidades o total no válidos. El total aprobado debe conservarse.',
  'allocation.stale': 'El reparto ha cambiado. Recarga la versión guardada antes de reintentar.',
  "budget.policy": "Cálculo de ausencias por calendario",
  "budget.policyHint": "Activa el cálculo por calendario para jornadas completas en días y permisos en horas según los turnos programados. Cada jornada programada se asigna a la fecha de inicio del turno, sin duplicarla al cruzar medianoche. Requiere horarios y calendarios verificados. Enfermedad mantiene su recorrido actual. No modifica el total de solicitudes anteriores ni acredita vacaciones. Actualiza y verifica las apps antes de activar: las versiones anteriores no pueden enviar estas solicitudes.",
  "budget.enabled": "Activo",
  "budget.disabled": "Desactivado",
  "budget.enable": "Activar cálculo por calendario",
  "budget.disable": "Desactivar para nuevas solicitudes",
  "budget.preview": "{count} días calculados por el servidor",
  "budget.fullDays": "El cálculo sigue el turno y el calendario. Los permisos por horas pueden cubrir parte de la jornada.",
  "budget.stale": "La configuración cambió. Recalcula antes de enviar. Para una solicitud pendiente: cancélala y créala con el nuevo cálculo.",
  "budget.scheduleRequired": "Falta una jornada compatible en el periodo. Pide a HR que la complete.",
  "budget.noWorkdays": "No hay jornadas laborables programadas en el periodo.",
  "budget.error": "No se pudo calcular la solicitud. Revisa los datos y reintenta.",
  "budget.noSavedAllocation": "Esta solicitud no tiene un reparto diario guardado. El total no se reconstruye con el calendario actual.",
  'member.tab.onboarding': 'Checklist de incorporación',
  'member.tab.deadlines': 'Vencimientos',
  'onboarding.checklist.title': 'Trámites y documentos de incorporación',
  'onboarding.checklist.hint': 'Verifica y marca los formularios y documentos entregados por el trabajador para su contratación. El trabajador ve el estado actualizado en su app (Mis datos).',
  'onboarding.checklist.task.identity_document': 'Documento de identidad y código fiscal',
  'onboarding.checklist.task.privacy_notice': 'Informativa de privacidad (art. 13 RGPD)',
  'onboarding.checklist.task.tfr_choice': 'Modelo de elección de destino del TFR (TFR 1 / TFR 2)',
  'onboarding.checklist.task.tax_deductions': 'Modelo de deducciones fiscales / cargas familiares',
  'onboarding.checklist.task.bank_details': 'Datos bancarios (IBAN abono de nómina)',
  'onboarding.checklist.task.employment_contract': 'Contrato vinculado con la versión laboral (no prueba la firma)',
  'onboarding.checklist.task.individual_agreement': 'Acuerdo individual previsto (no prueba la firma)',
  'onboarding.checklist.status.completed': 'Completado',
  'onboarding.checklist.status.pending': 'Pendiente',
  'onboarding.checklist.completedAt': 'Completado el {date}',
  'onboarding.checklist.completedBy': 'por {actor}',
  'onboarding.checklist.notes': 'Notas internas de RR. HH.',
  'onboarding.checklist.save': 'Guardar cambios',
  'onboarding.checklist.saved': 'Cambios guardados con éxito.',
  'deadlines.title': 'Calendario de vencimientos y trámites',
  'deadlines.hint': 'Seguimiento de vencimientos contractuales y obligaciones legales (período de prueba, fin de contratos, idoneidad médica, permiso de residencia, seguridad).',
  'deadlines.horizon': 'Horizonte temporal',
  'deadlines.horizon.30': 'Próximos 30 días',
  'deadlines.horizon.60': 'Próximos 60 días',
  'deadlines.horizon.90': 'Próximos 90 días',
  'deadlines.horizon.365': 'Año completo',
  'deadlines.category.probation_end': 'Fin de prueba',
  'deadlines.category.contract_end': 'Fin de contrato',
  'deadlines.category.medical_visit': 'Visita médica periódica (D.Lgs. 81/08)',
  'deadlines.category.residence_permit': 'Permiso de residencia',
  'deadlines.category.safety_training': 'Formación en seguridad',
  'deadlines.urgency.expired': 'Vencido',
  'deadlines.urgency.critical': 'Urgente (<= 15 d)',
  'deadlines.urgency.warning': 'Por vencer (<= 30 d)',
  'deadlines.urgency.upcoming': 'Programado',
  'deadlines.daysRemaining': '{n} d restantes',
  'deadlines.daysExpired': 'Vencido hace {n} d',
  'deadlines.empty': 'No hay vencimientos en el período seleccionado.',

  'breaks.title': 'Políticas de pausa',
  'breaks.description': 'Reglas de empresa para pausas de comida y descanso. Sin deducción automática.',
  'breaks.newPolicy': 'Nueva política de pausa',
  'breaks.editPolicy': 'Editar política de pausa',
  'breaks.name': 'Nombre',
  'breaks.nameRequired': 'El nombre debe tener al menos 2 caracteres',
  'breaks.type': 'Tipo',
  'breaks.isPaid': 'Pausa retribuida (computable como trabajo)',
  'breaks.isMandatory': 'Obligatoria',
  'breaks.minDuration': 'Duración mínima',
  'breaks.expectedDuration': 'Duración prevista',
  'breaks.validFrom': 'Válida desde',
  'breaks.validTo': 'Válida hasta',
  'breaks.minutes': 'minutos',
  'breaks.paid': 'Retribuida',
  'breaks.unpaid': 'No retribuida',
  'breaks.mandatoryBadge': 'Obligatoria',
  'breaks.activeIndefinitely': 'activa por tiempo indefinido',
  'breaks.durations': 'Duración prevista / mínima',
  'breaks.validity': 'Validez',
  'breaks.empty': 'No hay políticas de pausa configuradas.',
  'breaks.invalidDuration': 'La duración no puede ser negativa',
  'breaks.invalidDates': 'La fecha de fin debe ser posterior a la de inicio',

  'presence.liveTab': 'Presencias en tiempo real',
  'presence.exportTab': 'Exportación de presencias',
  'presence.breakStart': 'Inicio de pausa',
  'presence.breakEnd': 'Fin de pausa',

  'cartellino.tab': 'Cartellino mensual',
  'cartellino.title': 'Cartellino mensual',
  'cartellino.subtitle': 'Resumen mensual de presencias, pausas, horas trabajadas y anomalías por empleado.',
  'cartellino.downloadPdf': 'Descargar PDF',
  'cartellino.pdfTitle': 'Cartellino mensual de presencias',
  'cartellino.period': 'Mes de competencia',
  'cartellino.vatFiscalCode': 'NIF / CIF',
  'cartellino.summary': 'Resumen del mes',
  'cartellino.employerSignature': 'Firma del empleador / RR. HH.',
  'cartellino.employeeSignature': 'Firma del trabajador de conformidad',
  'cartellino.generatedAt': 'Generado el',
  'cartellino.footerNotice': 'Documento generado por Fide sobre la base de registros electrónicos inalterables.',
  'cartellino.employee': 'Empleado',
  'cartellino.prevMonth': 'Mes anterior',
  'cartellino.nextMonth': 'Mes siguiente',
  'cartellino.workedDays': 'Días trabajados',
  'cartellino.totalDaysInMonth': '{count} días en el mes',
  'cartellino.computableHours': 'Horas computables',
  'cartellino.expected': 'Previstas',
  'cartellino.noSchedule': 'Sin horario previsto',
  'cartellino.breaksSummary': 'Total pausas',
  'cartellino.paid': 'Retribuidas',
  'cartellino.unpaid': 'No retribuidas',
  'cartellino.paidShort': 'retribuida',
  'cartellino.anomalies': 'Anomalías / Incidencias',
  'cartellino.anomaliesHint': 'Eventos a verificar o corregir',
  'cartellino.date': 'Día',
  'cartellino.punches': 'Fichajes',
  'cartellino.breaks': 'Pausas',
  'cartellino.computable': 'Computable',
  'cartellino.leaves': 'Ausencias',
  'cartellino.status': 'Estado',
  'cartellino.regular': 'Regular',
  'cartellino.missingOut': 'Falta salida',
  'cartellino.missingIn': 'Falta entrada',
  'cartellino.unclosedBreak': 'Pausa no cerrada',
  'cartellino.breakWithoutStart': 'Fin de pausa sin inicio',
  'cartellino.breakOutsideShift': 'Pausa fuera de turno',
  'cartellino.shortBreak': 'Pausa inferior al mínimo',
  'cartellino.longShift': 'Turno de más de 16 horas',
  'cartellino.corrected': 'Corrección manual',
  'cartellino.flagged': 'Fichaje con aviso',
  'cartellino.scheduleDiscrepancy': 'Ausencia no justificada',
  'common.days.mon': 'Lun',
  'common.days.tue': 'Mar',
  'common.days.wed': 'Mié',
  'common.days.thu': 'Jue',
  'common.days.fri': 'Vie',
  'common.days.sat': 'Sáb',
  'common.days.sun': 'Dom',
  'compliance.status': "Estado administrativo",
  'compliance.scheduled': "Programado",
  'compliance.document_pending': "Documento pendiente",
  'compliance.verified': "Verificado",
  'breaks.versionRequired': "Crea una versión con vigencia posterior a las pausas ya registradas.",
  'error.bankConfiguration': "La banca de horas debe estar activa, expresada en horas y gestionar saldo.",
  "schedule.copyDay": "Copiar una jornada",
  "schedule.copyHint": "Copia todos los tramos del día elegido, incluidas las pausas entre tramos. Reemplaza los tramos de los días seleccionados en el editor: no guarda ni modifica fichajes. Después verifica el total contractual y guarda la nueva versión.",
  "schedule.copySource": "Día de origen",
  "schedule.copyTargets": "Días que se reemplazarán",
  "schedule.copyInvalid": "Elige una jornada con tramos válidos. La copia debe respetar el límite de 28 tramos y no generar solapamientos, incluida la noche del domingo al lunes.",
  "schedule.copySummary": "Tramos existentes reemplazados: {count}. Nuevo total semanal: {minutes} minutos.",
  "schedule.copyConfirm": "He revisado los días, los horarios y los tramos que se reemplazarán.",
  "schedule.copyApply": "Aplicar copia en el editor",
  "clockPolicy.methodsTitle": "Métodos de fichaje por ámbito y fecha",
  "clockPolicy.methodsHint": "El QR siempre permanece disponible. La versión activa más específica prevalece sobre equipo, sede y empresa. Los cambios empiezan como pronto mañana y el servidor los aplica.",
  "clockPolicy.company": "Empresa",
  "clockPolicy.site": "Sede",
  "clockPolicy.team": "Equipo",
  "clockPolicy.person": "Persona",
  "clockPolicy.scope": "Ámbito",
  "clockPolicy.target": "Destino",
  "clockPolicy.from": "Vigente desde",
  "clockPolicy.to": "Vigente hasta (opcional)",
  "clockPolicy.allowGeo": "Permitir también fichaje por geovalla en el dispositivo",
  "clockPolicy.geoLegal": "Actívala solo después de la revisión laboral y de privacidad requerida. La sede también debe tener la geovalla activada; no se guardan coordenadas.",
  "clockPolicy.source": "Referencia de la decisión o acuerdo",
  "clockPolicy.confirmMethods": "He revisado el ámbito, las fechas, el método y la referencia justificativa.",
  "clockPolicy.saveVersion": "Guardar versión de métodos",
  "clockPolicy.qrOnly": "Solo QR",
  "clockPolicy.qrGeo": "QR + geovalla",
  "shifts.title": "Turnos planificados",
  "shifts.explain": "La planificación está separada de los fichajes reales. Cada cambio crea una versión nueva y un aviso no leído para el trabajador. Se bloquean solapamientos y ausencias aprobadas.",
  "shifts.time": "Horario planificado",
  "shifts.notice": "Aviso al trabajador",
  "shifts.read": "Leído",
  "shifts.unread": "No leído",
  "shifts.cancelled": "Cancelado",
  "shifts.cancel": "Cancelar turno",
  "shifts.cancelTitle": "Cancelar el turno de {name}",
  "shifts.empty": "No hay turnos planificados en este periodo.",
  "shifts.add": "Planificar un turno",
  "shifts.edit": "Cambiar turno planificado",
  "shifts.start": "Inicio",
  "shifts.end": "Fin",
  "shifts.reason": "Motivo de esta versión",
  "shifts.note": "Nota para el trabajador (opcional)",
  "shifts.confirm": "He revisado la persona, sede, horarios, cobertura y conflictos.",
  "approvalPolicies.title": "Niveles de aprobación",
  "approvalPolicies.explain": "Configura el recorrido de las solicitudes nuevas. Cada solicitud conserva los niveles vigentes al enviarse; un cambio no reescribe decisiones iniciadas.",
  "approvalPolicies.empty": "No hay tipos de ausencia configurables.",
  "approvalPolicies.leaveType": "Tipo de ausencia",
  "approvalPolicies.flow": "Recorrido",
  "approvalPolicies.flowFor": "Recorrido de aprobación para {name}",
  "approvalPolicies.legacy": "Responsable o RR. HH. (un nivel)",
  "approvalPolicies.managerThenHr": "Responsable y después RR. HH.",
  "approvalPolicies.hrOnly": "Solo RR. HH.",
  "member.recordOvertime": "Registrar horas extra",
  "member.overtimeRecorded": "Horas extra registradas.",
  "mealVouchers.title": "Buoni pasto / Vales de comida (cálculo de días)",
  "mealVouchers.explain": "Configura cuándo un empleado genera derecho a un vale de comida en la jornada. Fide muestra el recuento en el cartellino (portal y app) y lo incluye en la exportación mensual para el asesor.",
  "mealVouchers.enabled": "Activar el cálculo de buoni pasto",
  "mealVouchers.minMinutes": "Minutos mínimos trabajados en la jornada (ej. 360 = 6 horas)",
  "mealVouchers.includePaidBreaks": "Incluir las pausas retribuidas para alcanzar el umbral",
  "mealVouchers.includeSmartWorking": "Incluir los días de Smart Working aprobados",
  "mealVouchers.save": "Guardar reglas de buoni pasto",
  "mealVouchers.saved": "Reglas de buoni pasto guardadas.",
  "mealVouchers.col": "Buoni pasto",
  "paghe.title": "Códigos de causal para el asesor (tracciato paghe)",
  "paghe.explain": "Asocia a cada concepto de Fide (horas ordinarias, ausencias, horas extra, buoni pasto) el código de causal del programa de nóminas del estudio (Zucchetti, TeamSystem, Inaz…). Déjalo vacío para usar el código estándar de Fide.",
  "paghe.fideCode": "Concepto Fide",
  "paghe.consultantCode": "Código programa de nóminas",
  "paghe.save": "Guardar código",
  "paghe.saved": "Código guardado.",
  "paghe.item.ORD": "Horas ordinarias trabajadas",
  "paghe.item.STRAORD_LIQ": "Horas extra a abonar en nómina",
  "paghe.item.STRAORD_BANCA": "Horas extra a bolsa de horas",
  "paghe.item.BUONO_PASTO": "Buono pasto generado",
  "report.pagheCsv": "Descargar movimientos con códigos de nómina (CSV)",
  "report.variationsCsv": "Descargar variaciones del mes (CSV)",
  "report.variationsSummary": "{n} variaciones registradas en el mes (altas/contratos, bajas, horas extra, ajustes de saldo, buoni pasto).",
  "report.var.col.kind": "Tipo de variación",
  "report.var.col.code": "Código nómina",
  "report.var.col.date": "Fecha / Periodo",
  "report.var.col.value": "Valor / Detalle",
  "report.var.kind.hire_or_contract": "Contrato / Encuadramiento",
  "report.var.kind.termination": "Baja laboral",
  "report.var.kind.overtime": "Horas extra aprobadas",
  "report.var.kind.balance_adjustment": "Ajuste de saldo",
  "report.var.kind.meal_vouchers": "Buoni pasto del mes",
  "communications.category": "Categoría de la comunicación",
  "communications.cat.notice": "Aviso",
  "communications.cat.circular": "Circular de empresa",
  "communications.cat.regulation": "Reglamento interno",
  "communications.cat.privacy_notice": "Informativa de privacidad (art. 13 RGPD)",
  "communications.cat.disciplinary_code": "Código disciplinario (art. 7 L. 300/1970)",
  "communications.requiresAck": "Solicitar confirmación explícita de lectura (presa visione) en la app",
  "communications.requiresAckHint": "Nunca se registra la apertura pasiva: solo queda constancia cuando el trabajador pulsa confirmar lectura.",
  "communications.ackCount": "Confirmaciones de lectura: {n}",
  "communications.ackShow": "Ver confirmaciones",
  "communications.ackHide": "Ocultar confirmaciones",
  "communications.ackEmpty": "Aún no hay confirmaciones registradas.",
  "hrDesk.title": "Ventanilla RR. HH. y cambio de datos",
  "hrDesk.intro": "Solicitudes enviadas por los trabajadores desde la app: cambio de IBAN, cambio de domicilio, familiares a cargo / deducciones, certificado de servicios y anticipo de TFR.",
  "hrDesk.empty": "No hay solicitudes en la ventanilla de RR. HH.",
  "hrDesk.cat.iban_change": "Cambio de IBAN",
  "hrDesk.cat.address_change": "Cambio de domicilio",
  "hrDesk.cat.family_dependents": "Familiares a cargo / deducciones",
  "hrDesk.cat.service_certificate": "Certificado de servicios",
  "hrDesk.cat.tfr_advance": "Anticipo de TFR",
  "hrDesk.cat.other": "Otra gestión RR. HH.",
  "hrDesk.status.pending": "Pendiente",
  "hrDesk.status.completed": "Completada",
  "hrDesk.status.rejected": "Rechazada",
  "hrDesk.status.cancelled": "Cancelada",
  "hrDesk.manage": "Gestionar",
  "hrDesk.complete": "Marcar como completada",
  "hrDesk.reject": "Rechazar",
  "hrDesk.noteLabel": "Respuesta o nota para el trabajador",
  "hrDesk.noteRequired": "Motivo obligatorio en caso de rechazo (mín. 3 caracteres)",
};


